<div *ngIf="dataIsUploaded" class="container">
  <div class="head">
    {{ 'MENU.SCHEDULES' | translate }}
  </div>
  <div class="add" (click)="onAddClick()">
    <mat-icon matTooltip="{{ 'COMMON.ADD' | translate }}">add</mat-icon>
  </div>
  <div class="table-container mat-elevation-z8">
    <table
      mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows>

      <ng-container
        *ngFor="let column of columnsToDisplay"
        matColumnDef="{{ column }}">
        <th mat-header-cell *matHeaderCellDef [ngSwitch]="column">
          <ng-template ngSwitchDefault>
            <div>{{ getColumnHeaderName(column) }}</div>
          </ng-template>
        </th>
        <td
          mat-cell *matCellDef="let element">
          <div class="wrap-cell" [ngSwitch]="column">
            <div class="cell">
              <ng-template ngSwitchCase="dayOfWeek">
                <mat-select [value]="element.dayOfWeek"
                            (selectionChange)="dayOfWeekSelectionChange(element.key, $event.value)"
                >
                  <mat-option *ngFor="let day of [-1,0,1,2,3,4,5,6]" [value]="day">
                    {{day | weekPipe}}
                  </mat-option>
                </mat-select>
              </ng-template>
              <ng-template ngSwitchCase="from">
                <input type="time"
                       (change)="onFromChange(element.key, $event.target.value)"
                       value="{{element.from}}">
              </ng-template>
              <ng-template ngSwitchCase="to">
                <input type="time"
                       (change)="onToChange(element.key, $event.target.value)"
                       value="{{element.to}}">
              </ng-template>
              <ng-template ngSwitchCase="name">
                <input type="text"
                       (change)="onNameChange(element.key, $event.target.value)"
                       value="{{element.name}}">
              </ng-template>
              <ng-template ngSwitchCase="edit">
                <mat-icon
                  *ngIf="!element.allMenu"
                  class="list-alt"
                  (click)="selectProductsClick(element.key)"
                  matTooltip="{{ 'MENU.SELECT_PRODUCTS_IN_GROUP' | translate }}"
                  matTooltipPosition="left"
                >
                  list_alt
                </mat-icon>
                <mat-icon
                  *ngIf="!element.allMenu"
                  class="list-alt"
                  (click)="selectGroupsClick(element.key)"
                  matTooltip="{{ 'MENU.SELECT_GROUPS' | translate }}"
                  matTooltipPosition="right"
                >
                  folder
                </mat-icon>
                <mat-icon
                  *ngIf="isChanged(element) || element.isDeleted || element.isCreated"
                  class="cancel"
                  (click)="cancelChange(element)"
                  matTooltip="{{ 'COMMON.CANCEL' | translate }}">
                  undo
                </mat-icon>
              </ng-template>
              <ng-template ngSwitchCase="allMenu">
                <mat-checkbox
                  [checked]="element.allMenu"
                  (change)="changeAllMenu(element.key, $event.checked)"
                  type="checkbox">
                </mat-checkbox>
              </ng-template>
              <ng-template ngSwitchCase="isActive">
                <mat-checkbox
                  [checked]="element.isActive"
                  (change)="changeIsActive(element.key, $event.checked)"
                  type="checkbox">
                </mat-checkbox>
              </ng-template>
              <ng-template ngSwitchCase="delete">
                <mat-icon
                  class="clear"
                  matTooltip="{{ 'COMMON.DELETE' | translate }}"
                  (click)="clearScheduleClick(element.key)">
                  clear
                </mat-icon>
              </ng-template>
            </div>
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="columnsToDisplay; sticky: true">
      </tr>
      <tr [ngClass]="{isCreated: element.isCreated, isChanged: isChanged(element), isDeleted: element.isDeleted}"
        mat-row
        *matRowDef="let element; columns: columnsToDisplay">
      </tr>
    </table>
  </div>
  <div class="buttons">
    <button mat-button color="primary" [disabled]=""
            (click)="saveAllAsync()">
      {{'COMMON.SAVE'|translate}}
    </button>

    <button mat-button color="warn" (click)="exit()">
      {{ "COMMON.CANCEL" | translate }}
    </button>
  </div>
</div>
<mat-spinner *ngIf="!dataIsUploaded" diameter="48"></mat-spinner>
